import { useEffect, useState } from "react";
import './Report.css'
import { ExportJsonCsv } from 'react-export-json-csv';
import {  useLocation } from 'react-router-dom';
import axios from 'axios';
import { useInterval } from "../utils/useInterval";
import { useNavigate } from "react-router-dom";
import Header from '../common/Header'
import JSZip from  'jszip';
import { saveAs } from 'file-saver';
const Report = () => {
    const location = useLocation();
	const navigate = useNavigate();
    const [listRuang, setListRuang] = useState([])
    const [submissionSelected, setSubmissionSelected] = useState(true)
    const link = 'https://backend-ta-wiyata.herokuapp.com'
    const sessionData = location.state.sessionData
    const userData = location.state.userData
    const SESSION_ID = sessionData['id']
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    var date = new Date(sessionData['waktu_mulai'].split(" ")[0]);
    date = date.toLocaleDateString('en-GB', options)
    useEffect(() => {
		axios.get(`https://backend-ta-wiyata.herokuapp.com/get-report/${SESSION_ID}/`)
			.then(function (response) {
				setListRuang(response.data.data)
			})
			.catch((error) => {
                console.log(error)
			})
		
	}, [])
    useInterval(async () => {
		axios.get(`https://backend-ta-wiyata.herokuapp.com/get-report/${SESSION_ID}/`)
            .then(function (response) {
                setListRuang(response.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
	}, 5000)
    const headersCSV = [
        {
            key:'ruang',
            name: 'Discussion Room'
        },
        {
            key:'name',
            name: 'Nama Mahasiswa'
        },
        {
            key: 'npm',
            name: 'NPM',
        },
        {
            key: 'total',
            name: 'Total Nilai'
        }
    ]
    const dataCSV = () => {
        let data = []
        for(let i=0;i<listRuang.length;i++){
            let ruang = listRuang[i]
            for(let j=0;j<ruang.peserta.length;j++){
                let peserta = ruang.peserta[j]
                let dataPeserta = {
                    'ruang': ruang.nama_ruang,
                    'name': peserta.nama_peserta,
                    'npm' : peserta.npm_peserta,
                    'total' : peserta.peer_review
                }
                data.push(dataPeserta)
            }
        }
        return data

    }
    const dataSubmission = () =>{
        let listSubmissionUrl = []
        for(let i=0;i<listRuang.length;i++){
            let submisi = listRuang[i].submisi
            for(let j=0;j<submisi.length;j++){
                listSubmissionUrl.push(link+submisi[j].file_hasil_diskusi)
            }
        }
        return listSubmissionUrl
    }
    const handleZipSubmission = () =>{
        const urls = dataSubmission()
        const filename = sessionData['waktu_mulai']+'_'+sessionData['mata_kuliah']+'_'+sessionData['topik_diskusi']
        const zip = new JSZip()
        const folder = zip.folder('submission')
        urls.forEach((url)=> {
            const blobPromise =  fetch(url)    
            .then(function (response) {  
                console.log({response})             
                    if (response.status === 200 || response.status === 0) {
                        return Promise.resolve(response.blob());
                    } else {
                        return Promise.reject(new Error(response.statusText));
                    }
                })                          
                const name = url.substring(url.lastIndexOf('/'))
                        folder.file(name, blobPromise)
        })

        zip.generateAsync({type:"blob"})
            .then(blob => saveAs(blob, filename))
            .catch(e => console.log(e));

    }
    const handleToLobby = () => {
		navigate("/lobby", {
			state:{
				sesi: sessionData,
				userData:  userData
			}
		});
	}
    const getFileName = (fileUrl) =>{
        let file = fileUrl.split("/")
        file = file[file.length-1]
        return file
    }
	return (
		<div>
            <Header />
            <div className="report">
                <div className="report__back" onClick={handleToLobby}>
                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M26.25 13.75H8.5375L13.0125 9.2625L11.25 7.5L3.75 15L11.25 22.5L13.0125 20.7375L8.5375 16.25H26.25V13.75Z" fill="#165A7C"/>
                    </svg>
                    <div className="report__back--text">Back</div>
                </div>
                <h1>Discussion Session Report</h1>
                <div className="report__session-information">
                    <p className="report__session-information--course">{sessionData['mata_kuliah']}</p>
                    <p>{sessionData['topik_diskusi']}</p>
                    <p>{date}</p>
                    <p>{sessionData['waktu_mulai'].split(" ")[1]} - {sessionData['waktu_akhir'].split(" ")[1]}</p>
                </div>
                <div className="report__menu">
                    <div className={submissionSelected ? "report__menu-tab tab--active" : "report__menu-tab"} onClick={() =>{setSubmissionSelected(true)}}>Submission</div>
                    <div className={!submissionSelected ? "report__menu-tab tab--active" : "report__menu-tab"} onClick={() =>{setSubmissionSelected(false)}}>Peer Review</div>
                </div>
                {!submissionSelected ? 
                    <div  className="report__item">
                        <table>
                            <tr>
                                <th>Discussion Room</th>
                                <th>Student's Name</th>
                                <th>Student's ID</th>
                                <th>Score</th>
                            </tr>
                            {listRuang.map((ruang,index)=>
                                <tbody key={index}>
                                {ruang.peserta.map((mahasiswa,idxPeserta)=>
                                    mahasiswa.role_peserta == 'STUDENT' ?
                                    <tr key={idxPeserta}>
                                        <td>{ruang.nama_ruang}</td>
                                        <td>{mahasiswa.nama_peserta}</td>
                                        <td>{mahasiswa.npm_peserta}</td>
                                        <td>{mahasiswa.peer_review}</td>
                                    </tr>
                                    : null
                                )}
                                </tbody>
                            )}
                        </table>
                        <ExportJsonCsv className="wiyata-btn" headers={headersCSV} items={dataCSV()} fileTitle={sessionData['waktu_mulai']+'_'+sessionData['mata_kuliah']+'_'+sessionData['topik_diskusi']}>Export</ExportJsonCsv>
                    </div>
                :
                    <div  className="report__item">
                        <table>
                            <tr>
                                <th>Discussion Room</th>
                                <th>Student's Name</th>
                                <th>Submission File</th>
                            </tr>
                            {listRuang.map((ruang,index)=>
                                <tbody key={index}>
                                {ruang.submisi.length > 0 ?
                                    ruang.submisi.map((file,idxSubmisi)=>
                                        <tr key={idxSubmisi}>
                                            <td>{ruang.nama_ruang}</td>
                                        <td>{file.pengirim}</td>
                                            <td><a href={link+file.file_hasil_diskusi} target="_blank" >{getFileName(file.file_hasil_diskusi)}</a></td>
                                        </tr>
                                    )
                                :null}
                                </tbody>
                            )}
                        </table>
                        <button className="wiyata-btn" onClick={handleZipSubmission}>
                            Export
                        </button>
                    </div>
                }
            </div>
		</div>
	);
}
 
export default Report;
